import React, { useEffect, useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, imgUrl } from "../../lib/api";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";

const clearParam = () => {
  const u = new URL(window.location.href);
  u.searchParams.delete("markpost");
  window.history.replaceState(null, "", u.pathname + u.search);
};

export const MarkPostedDialog = () => {
  const [id] = useState(() => new URLSearchParams(window.location.search).get("markpost"));
  const [item, setItem] = useState(null);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(!!id);
  useEffect(() => {
    if (!id) return;
    Promise.all([api.get("/admin/fb/schedule"), api.get("/admin/social"), api.get("/admin/fb/pictures")]).then(([s, so, pi]) => {
      const it = s.data.find((x) => x.id === id);
      if (!it) { toast.error("That post is no longer in your schedule"); setOpen(false); clearParam(); return; }
      const v = (so.data.posts || []).find((p) => p.n === it.post_n);
      const pc = pi.data.find((p) => p.id === it.picture_id);
      setItem({ ...it, title: it.kind === "video" ? `Video Post ${it.post_n}${v?.title ? ` — ${v.title}` : ""}` : `Picture post${pc?.title ? ` — ${pc.title}` : ""}`, thumb: it.kind === "video" ? v?.thumb_url : pc?.url });
    }).catch(() => { toast.error("Could not load that post"); setOpen(false); });
  }, [id]);
  const close = () => { setOpen(false); clearParam(); };
  const confirm = async () => {
    setBusy(true);
    try { await api.put(`/admin/fb/schedule/${id}`, { posted: true }); toast.success("Marked as posted"); close(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not update"); } finally { setBusy(false); }
  };
  if (!id) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="sm:max-w-md" data-testid="mark-posted-dialog">
        <DialogTitle className="text-[18px] font-bold text-[#0f2e2a]">Mark as posted?</DialogTitle>
        {!item ? <Loader2 className="mx-auto animate-spin text-[#0e8c7f]" /> : (
          <div className="space-y-4">
            <div className="flex gap-3">
              {item.thumb && <img src={imgUrl(item.thumb)} alt="" className="h-28 w-20 shrink-0 rounded-lg object-cover" />}
              <div className="min-w-0">
                <div className="font-bold text-[#0f2e2a]" data-testid="mark-posted-title">{item.title}</div>
                <div className="text-[13px] text-[#5b6d6a]">{item.date} · {item.time} Eastern</div>
                {item.posted && <div className="mt-1 text-[13px] font-semibold text-[#0b6f65]" data-testid="mark-posted-already">Already marked posted</div>}
              </div>
            </div>
            <div className="flex gap-2">
              <button onClick={confirm} disabled={busy || item.posted} className="sw-btn-primary flex-1 justify-center !py-2.5 disabled:opacity-60" data-testid="mark-posted-confirm">{busy ? <Loader2 size={16} className="animate-spin" /> : <CheckCircle2 size={16} />}Yes, I posted it</button>
              <button onClick={close} className="sw-btn-outline !py-2.5" data-testid="mark-posted-cancel">Not yet</button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
